import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer, Event } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import dayjs, { Dayjs } from "dayjs";
import { useStyles } from "../../../theme/appStyles";
import '../../../App.css'; // Import your custom styles
import {
  ICompanyDetails,
  ICustomer,
  IProductPopUP,
  ITaxes,
  IEmailTemplate,
  IDriver
} from "../../../Api/Interface/api.interface";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useGetAllSearchCompanyQuery,
  useGetAllWorkOrderHistoryQuery,
  useGetAllInvoiceHistoryQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useGetWorkOrderQuery,
  useUpdateInvoiceStatusQuery,
  useGetEmailTemplateQuery,
  useGetAllInvoiceQuery,
  useGetDriverQuery,
} from "../../../Api/attoDeskApi";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Select
} from "@mui/material";
import { useNavigate } from "react-router-dom"; 

// Define localizer
const localizer = momentLocalizer(moment);

// Define TypeScript interface for a booking
interface Booking {
  id: number;
  gameType: string;
  customerName: string;
  startTime: string;
  endTime: string;
}

  interface IProduct {
    productName: string;
    productDescription: string;
    productImg: String | null;
    numberOfPassengers: number | null;
    transferType: string;
    transferTypeFrom: string;
    transferTypeTo: string;
    transferTypeDescription: string;
    departureDateTime: Dayjs | null;
    returnDateTime: Dayjs | null;
    departureAddress: string;
    destinationAddress: string;
    multiDestination: string;
    quantity: number | null;
    price: number | null;
    tax: number | null;
    taxAmount: number | null;
    total: number;
    taxId: number | null;
    unitPriceWithDiscount: number | null;
    unitTotalWithDiscount: number;
    productType: string;
    productLongDescription: string;
    productShortDescription: string;
  }
  
  interface IDiscount {
    value: number | null;
    description: string;
  }
  
  interface IQuoteWorkOrder {
    id: number;
    quoteWorkOrderCompanyId: number;
    quoteWorkOrderCustomerId: string;
    quoteWorkOrderNo: string;
    quoteWorkOrderIssueDate: Dayjs;
    quoteWorkOrderDueDate: Dayjs;
    quoteWorkOrderAmount: number | null;
    quoteWorkOrderStatus: number;
    quoteWorkOrderSale: IProduct[];
    quoteWorkOrderDiscount: string;
    quoteWorkOrderSubTotal: string;
    quoteWorkOrderSaleGrandTotal: string;
    quoteWorkOrderSaleDiscountDescription: IDiscount[];
    customer: ICustomer;
    company: ICompanyDetails;
    quoteWorkOrderCustomerRemark: string;
    quoteWorkOrderCustomerMemo: string;
    quoteWorkOrderSaleDiscount: string;
    quoteWorkOrderSaleSubTotal: string;
    created_by: number;
    created_at: string;
    mainStatus: number;
    invoiceId: number;
    payment_id: string;
  }
  interface IInvoice {
    id: number;
    work_order_id: string;
    quoteWorkOrderCompanyId: number;
    quoteWorkOrderCustomerId: string;
    quoteWorkOrderNo: string;
    quoteWorkOrderIssueDate: Dayjs;
    quoteWorkOrderDueDate: Dayjs;
    quoteWorkOrderAmount: number | null;
    quoteWorkOrderStatus: number;
    quoteWorkOrderSale: IProduct[];
    quoteWorkOrderDiscount: string;
    quoteWorkOrderSubTotal: string;
    quoteWorkOrderSaleGrandTotal: string;
    quoteWorkOrderSaleDiscountDescription: IDiscount[];
    customer: ICustomer;
    company: ICompanyDetails;
    quoteWorkOrderCustomerRemark: string;
    quoteWorkOrderCustomerMemo: string;
    quoteWorkOrderSaleDiscount: string;
    quoteWorkOrderSaleSubTotal: string;
    created_by: number;
    created_at: string;
    mainStatus: number;
    invoiceId: number;
    payment_id: string;
    amount_paid: number;
    due_amount: number;
  }

  // Define TypeScript type for events
interface CalendarEvent extends Event {
  title: string;
  start: Date;
  end: Date;
  
}
const BookingCalendar = () => {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
   const classes = useStyles();
   const theme = useTheme();
   const navigate = useNavigate();

  const { data: workOrderData, isLoading: workIsLoading, isError: workOrderError } = useGetWorkOrderQuery({ searchText: "", id: "" });
  const { data: invoiceData, isLoading: invoiceIsLoading, isError: invoiceError } = useGetAllInvoiceQuery({ searchText: "", id: "", quoteWorkOrderCustomerId: "", quoteWorkOrderCustomerProjectId: "" });
  const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({searchText: "", id: "",});
  const {data: customerData,isLoading: customerIsLoading,isError: cutomerError,refetch: cutomerRefetch,} = useGetCustomerQuery({searchText: "",id: "",});
  
  const { data: driverData,  isLoading: driverIsLoading, isError: driverError,refetch: driverRefetch,} = useGetDriverQuery({ searchText: "",id: "",});
 // const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
 const capitalize = (str: string | null | undefined): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [selectedCustomer, setSelectedCustomer] = useState<string>("");

  React.useEffect(() => {
    document.documentElement.style.setProperty("--primary-color", theme.palette.primary.main);
    document.documentElement.style.setProperty("--primary-dark", theme.palette.primary.dark);
  }, [theme]); 


  useEffect(() => {
    let bookings: any[] = [];
    
    // If workOrderData exists and contains the expected array (e.g., workOrderData.data)
    // if (workOrderData && Array.isArray(workOrderData.data) &&  workOrderData.data.filter(work => work.invoiceId == null) ) {
    //   bookings = workOrderData.data.map((workOrder: any) => {
    //     return workOrder.quoteWorkOrderSale.map((sale: any) => ({
    //       title: `${sale.productName} - ${sale.productDescription}`,
    //       start: new Date(sale.departureDateTime), // Departure DateTime as start
    //       end: new Date(sale.returnDateTime), // Return DateTime as end
    //       allDay: false,
    //     }));
    //   });
    // }
   
    // else
    if (invoiceData && Array.isArray(invoiceData.data)) {


     const filteredInvoices = invoiceData.data.filter((invoice: any) => {
     const matchCompany = selectedCompany ? Number(invoice.quoteWorkOrderCompanyId) === Number(selectedCompany) : true;
      const matchCustomer = selectedCustomer ? Number(invoice.quoteWorkOrderCustomerId) === Number(selectedCustomer) : true;

      return matchCompany && matchCustomer;
    });

      
      // bookings = filteredInvoices.flatMap((invoice: any) =>
      //   invoice.quoteWorkOrderSale.map((sale: any) => ({
      //     title: `${invoice.quoteWorkOrderNo} | ${sale.productName} | ${dayjs(sale.departureDateTime).format('h:mm A')} ${
      //       sale.returnDateTime ? `- ${dayjs(sale.returnDateTime).format('h:mm A')}` : ''
      //     } | ${sale.transferTypeFrom} to ${sale.transferTypeTo} ${
      //       Array.isArray(invoice?.drivers) && invoice.drivers.length
      //         ? `(Drivers: ${invoice.drivers
      //             .map((driver: { driverFirstName: string; driverLastName: string }) =>
      //               `${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)}`
      //             )
      //             .join(', ')})`
      //         : ''
      //     }`,
  
      //     start: new Date(sale.departureDateTime), // Always set start as departure
      //     end: sale.returnDateTime ? new Date(sale.returnDateTime) : new Date(sale.departureDateTime), // If no return, set end same as start
      //     allDay: false,
      //     workOrderId: invoice.work_order_id,
      //   }))



 bookings = filteredInvoices.flatMap((invoice: any) =>
      invoice.quoteWorkOrderSale.map((sale: any) => {
        // Collect all datetime values from pickups, dropoffs, returnPickups, returnDropoffs
        const allTimes = [
          ...(sale.pickups || []).map((p: any) => p.dateTime).filter(Boolean),
          ...(sale.dropoffs || []).map((d: any) => d.dateTime).filter(Boolean),
          ...(sale.returnPickups || []).map((rp: any) => rp.dateTime).filter(Boolean),
          ...(sale.returnDropoffs || []).map((rd: any) => rd.dateTime).filter(Boolean),
        ].filter(dt => dayjs(dt).isValid());

        // Determine start and end times
        const startTime = allTimes.length 
          ? new Date(Math.min(...allTimes.map(t => new Date(t).getTime())))
          : new Date();
        const endTime = allTimes.length 
          ? new Date(Math.max(...allTimes.map(t => new Date(t).getTime())))
          : startTime;

        // Build location string
        const firstPickup = (sale.pickups || [])[0];
        const lastDropoff = [...(sale.dropoffs || []), ...(sale.returnDropoffs || [])].slice(-1)[0];
        
        const fromLocation = firstPickup?.city || firstPickup?.address || sale.transferTypeFrom || '';
        const toLocation = lastDropoff?.city || lastDropoff?.address || sale.transferTypeTo || '';

        // Build time display
        const timeDisplay = `${dayjs(startTime).format('h:mm A')}${
          endTime.getTime() !== startTime.getTime() ? ` - ${dayjs(endTime).format('h:mm A')}` : ''
        }`;

        return {
          title: `${invoice.quoteWorkOrderNo} | ${sale.productName} | ${timeDisplay} | ${fromLocation} to ${toLocation}${
            Array.isArray(invoice?.drivers) && invoice.drivers.length
              ? ` (Drivers: ${invoice.drivers
                  .map((driver: { driverFirstName: string; driverLastName: string }) =>
                    `${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)}`
                  )
                  .join(', ')})`
              : ''
          }`,
          start: startTime,
          end: endTime,
          allDay: false,
          workOrderId: invoice.work_order_id,
        };
      })





      );
    }
  
    setEvents(bookings);
  }, [ invoiceData,selectedCompany, selectedCustomer]);





  const handleEventClick = (event: CalendarEvent) => {
    const workOrderId = event.workOrderId;
    navigate(`/work-order/history/${workOrderId}`); // Navigate to the work order details page
  };
  


  return (


      <>
      <Grid container spacing={1} sx={{ marginTop: 1 }}>
           <Grid item xs={12}>
             <Card className={classes.card}>
          <Box mb={2} padding={2}>
          <Grid container spacing={2}>
           <Grid item lg={2} md={3} sm={6} xs={12}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
              Issue From
            </Typography>
            <Select
              className={classes.textField}
              value={selectedCompany || ""}
              onChange={(event) => setSelectedCompany(event.target.value)}
              displayEmpty
              sx={{
                height: "37px",
                fontSize: "14px",
                padding: "4px",
                minWidth: "120px"
              }}
            >
              <MenuItem value="">All Companies</MenuItem>
              {companyData && Array.isArray(companyData.data) ? (
                companyData.data.map((company: any) => (
                  <MenuItem key={company.id} value={company.id}>
                    {`${capitalize(company.companyName)}`}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No data available</MenuItem>
              )}
            </Select>
          </Grid>
          
                 <Grid item lg={2} md={3} sm={6} xs={12}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
              Issue For
            </Typography>
            <Select
              className={classes.textField}
              value={selectedCustomer || ""}
              onChange={(event) => setSelectedCustomer(event.target.value)}
              displayEmpty
              sx={{
                height: "37px",
                fontSize: "14px",
                padding: "4px",
                minWidth: "120px"
              }}
            >
              <MenuItem value="">All Customers</MenuItem>
              {customerData && Array.isArray(customerData.data) ? (
                customerData.data.map((customer: any) => (
                  <MenuItem key={customer.id} value={customer.id}>
                   {`${capitalize(customer.customerFirstName || '')} ${capitalize(customer.customerLastName || '')}`}
          
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No data available</MenuItem>
              )}
            </Select>
          </Grid>
           <Grid item xs />

 <Grid item>
  <Button
    variant="contained"
    size="small"
    sx={{ mt: 3 }}
    onClick={() => navigate("/booking/list")}
  >
    List View
  </Button>
</Grid>

        
          
                     </Grid>
                     
                   </Box>
                   </Card>
                   </Grid>
                   </Grid>

    <div  style={{ height: 600, padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0,0,0,0.1)" }}>
    <Calendar 
      localizer={localizer}
      events={events}
      startAccessor="start"
      endAccessor="end"
      style={{ height: "100%" , whiteSpace: "none" }}
   
      eventPropGetter={(event: any) => ({
        style: {
          backgroundColor: "green", 
          color: "#fff",
          borderRadius: "4px",
          padding: "5px",
          fontSize: "11px",
          whiteSpace: 'normal !important', // Force wrap
          wordBreak: "break-word", // Ensure words break correctly
           overflow: "visible", // Ensure the content isn't clipped
        },
      })}

      onSelectEvent={handleEventClick} 
    />
  </div>
  </>
  );
};

export default BookingCalendar;